(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["hero-slideshow-asia"] && !window.DesignMode) return;
  try {
    
   document.addEventListener( 'DOMContentLoaded', function () {
      new Splide( '#image-slider', {
         type   : 'loop',
         waitForTransition: false,
         perPage: 1,
         padding: {
             right: '10rem',
             left : '10rem',
         },
         breakpoints: {
             900: {
                 padding: {
                     right: '0',
                     left : '0',
                 },
             },
         },
         pagination: false,
     }).mount();
   } );

   document.addEventListener("shopify:section:load", function(){
      new Splide( '#image-slider', {
         type   : 'loop',
         waitForTransition: false,
         perPage: 1,
         padding: {
             right: '10rem',
             left : '10rem',
         },
         breakpoints: {
             900: {
                 padding: {
                     right: '0',
                     left : '0',
                 },
             },
         },
         pagination: false,
     }).mount();
   });
   
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow-retro"] && !window.DesignMode) return;
  try {
    
   document.addEventListener( 'DOMContentLoaded', function () {
      new Splide( '#image-slider', {
         type   : 'loop',
         waitForTransition: false,
         perPage: 1,
         padding: {
             right: '10rem',
             left : '10rem',
         },
         breakpoints: {
             900: {
                 padding: {
                     right: '0',
                     left : '0',
                 },
             },
         },
         pagination: false,
     }).mount();
   } );

   document.addEventListener("shopify:section:load", function(){
      new Splide( '#image-slider', {
         type   : 'loop',
         waitForTransition: false,
         perPage: 1,
         padding: {
             right: '10rem',
             left : '10rem',
         },
         breakpoints: {
             900: {
                 padding: {
                     right: '0',
                     left : '0',
                 },
             },
         },
         pagination: false,
     }).mount();
   });
   
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !window.DesignMode) return;
  try {
    
         document.addEventListener( 'DOMContentLoaded', function () {
            new Splide( '#image-slider', {
               type   : 'loop',
               waitForTransition: false,
               perPage: 1,
               speed: 400,
               padding: {
                  right: '10rem',
                  left : '10rem',
               },
               breakpoints: {
                  1200: {
                     padding: {
                           right: '0',
                           left : '0',
                     },
                  },
               },
               pagination: false,
            }).mount();
         } );

         document.addEventListener("shopify:section:load", function(){
            new Splide( '#image-slider', {
               type   : 'loop',
               waitForTransition: false,
               perPage: 1,
               speed: 400,
               padding: {
                  right: '10rem',
                  left : '10rem',
               },
               breakpoints: {
                  1200: {
                     padding: {
                           right: '0',
                           left : '0',
                     },
                  },
               },
               pagination: false,
            }).mount();
         });
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recomendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

})();
